export default __webpack_public_path__ + "img/25ea97fb07ea6cf676d32a2037436c16.svg";